(() => {
  const initialise = () => {
    const forms = [...document.querySelectorAll('.pv-quote-form')];
    const setContext = (form, url) => {
      const selected = form.querySelector('[data-quote-package]');
      const quantity = form.querySelector('[data-quote-quantity]');
      const packageValue = url.searchParams.get('package');
      if (selected && quantity && ['12', '24', '48', 'custom'].includes(packageValue)) {
        selected.value = packageValue;
        if (packageValue !== 'custom') quantity.value = packageValue;
        quantity.dispatchEvent(new Event('input', { bubbles: true }));
      }
      const category = url.searchParams.get('occasion');
      if (['business', 'community', 'event'].includes(category)) {
        let field = form.querySelector('input[name="contact[Project category]"]');
        if (!field) {
          field = document.createElement('input');
          field.type = 'hidden';
          field.name = 'contact[Project category]';
          form.append(field);
        }
        field.value = category;
      }
    };
    forms.forEach(form => {
      const quantity = form.querySelector('[data-quote-quantity]');
      const selected = form.querySelector('[data-quote-package]');
      const estimate = form.querySelector('[data-quote-estimate]');
      if (!quantity || !selected || !estimate) return;
      const updateEstimate = () => {
        const count = Number(quantity.value);
        estimate.replaceChildren();
        if (!Number.isInteger(count) || count < 1 || count > 500) {
          estimate.textContent = estimate.dataset.empty;
          return;
        }
        const rate = count < 24 ? 35 : count < 48 ? 33 : 31;
        const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: estimate.dataset.currency || 'USD', maximumFractionDigits: 0 });
        const headline = document.createElement('strong');
        headline.textContent = `${estimate.dataset.label} ${money.format(count * rate)}`;
        const note = document.createElement('small');
        note.textContent = estimate.dataset.note;
        estimate.append(headline, note);
      };
      selected.addEventListener('change', () => {
        const amount = selected.selectedOptions[0]?.dataset.quantity;
        if (amount) quantity.value = amount;
        updateEstimate();
      });
      quantity.addEventListener('input', () => {
        if (selected.value !== 'custom' && quantity.value !== selected.value) selected.value = 'custom';
        updateEstimate();
      });
      setContext(form, new URL(window.location.href));
      updateEstimate();
    });
    document.querySelectorAll('.pv-mobile-nav a').forEach(link => link.addEventListener('click', () => link.closest('details')?.removeAttribute('open')));
    document.querySelectorAll('a[href*="#quote"]').forEach(link => link.addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      const url = new URL(link.href, window.location.href);
      const normalisePath = path => path.replace(/\/$/, '') || '/';
      const target = document.getElementById('quote');
      if (url.origin !== window.location.origin || normalisePath(url.pathname) !== normalisePath(window.location.pathname) || !target) return;
      event.preventDefault();
      forms.forEach(form => setContext(form, url));
      window.history.replaceState(null, '', url.href);
      target.setAttribute('tabindex', '-1');
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      target.focus({ preventScroll: true });
    }));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
})();
